import { routes } from '@/config/routes';
import { DUMMY_ID } from '@/config/constants';
import {
  PiShoppingCartDuotone,
  PiChartBarDuotone,
  PiReceiptLight,
  PiHouse,
  PiCirclesThreePlusBold,
  PiHardDrivesLight,
  PiChartLineUp,
  PiGarage,
  PiImage,
  PiTag,
  PiCube,
  PiCreditCard,
  PiUser,
  PiStudent,
  PiRocketLaunch,
  PiGear,
  PiPaintBrush,
  PiWrench,
  PiStar,
  PiBuildings,
  PiNewspaperBold,
  PiChartBar,
  PiChatTeardropText,
  PiPhoneCall,
  PiFacebookLogo,
  PiInstagramLogo,
  PiPersonSimpleBike,
  PiUserSwitch,
  PiPackage,
  PiBellRingingDuotone,
  PiFile,
  PiStorefrontBold
} from 'react-icons/pi';

import { HiReceiptRefund } from 'react-icons/hi2';
import { TbReport } from 'react-icons/tb';
import { HiDocumentReport } from 'react-icons/hi';
import { BiSolidReport } from 'react-icons/bi';

export const menuItems = [
  {
    name: 'Home',
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },

  {
    name: 'Home',
    href: routes.features,
    icon: <PiNewspaperBold />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },

  {
    name: 'Dashboard ',
    href: routes.eCommerce.dashboard,
    icon: <PiHouse />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'DELIVERY MAN'],
  },

  {
    name: 'POS',
    href: routes.pos,
    icon: <PiBuildings />,
    roles: ['VENDOR', 'WHOLESALER', 'EMPLOYEE', 'haspos'],
    dropdownItems: [
      { name: 'Terminal', href: routes.pos },
      { name: 'Sales', href: routes.posSales },
      { name: 'Register', href: routes.posRegister },
      { name: 'Stock & barcodes', href: routes.posStock },
      { name: 'Staff', href: routes.posStaff },
      { name: 'Settings', href: routes.posSettings },
    ],
  },

  {
    name: 'Analytics',
    href: routes.analytics,
    icon: <PiChartLineUp />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },


  {
    name: 'KYC',
    href: routes.eCommerce.wholesalerKyc,
    icon: <PiBuildings />,
    roles: ['WHOLESALER'],
  },

  {
    name: 'Business Category',
    href: routes.businessCategory,
    icon: <PiChartBarDuotone />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },
  {
    name: 'Order management',
    helpModal: 'ORDERS_HELP',
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },
  {
    name: 'Orders',
    href: '#',
    icon: <PiShoppingCartDuotone />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'All',
        href: `${routes.eCommerce.orders}?status=all`,
      },
      {
        name: 'Pending',
        href: `${routes.eCommerce.orders}?status=pending`,
      },
      {
        name: 'Confirmed',
        href: `${routes.eCommerce.orders}?status=confirmed`,
      },
      {
        name: 'Out For Delivery',
        href: `${routes.eCommerce.orders}?status=out-of-delivery`,
      },
      {
        name: 'Delivered',
        href: `${routes.eCommerce.orders}?status=delivered`,
      },
      {
        name: 'Returned',
        href: `${routes.eCommerce.orders}?status=returned`,
      },
      {
        name: 'Canceled',
        href: `${routes.eCommerce.orders}?status=canceled`,
      },
    ],
  },
  {
    name: 'Orders',
    href: '#',
    icon: <PiPersonSimpleBike />,
    roles: ['DELIVERY MAN'],
    dropdownItems: [
      {
        name: 'All',
        href: `${routes.eCommerce.deliveryOrders}?status=all`,
      },
      {
        name: 'Pending',
        href: `${routes.eCommerce.deliveryOrders}?status=pending`,
      },
      {
        name: 'Confirmed',
        href: `${routes.eCommerce.deliveryOrders}?status=confirmed`,
      },
      {
        name: 'Out For Delivery',
        href: `${routes.eCommerce.deliveryOrders}?status=out-of-delivery`,
      },
      {
        name: 'Delivered',
        href: `${routes.eCommerce.deliveryOrders}?status=delivered`,
      },
      {
        name: 'Returned',
        href: `${routes.eCommerce.deliveryOrders}?status=returned`,
      },
      {
        name: 'Canceled',
        href: `${routes.eCommerce.deliveryOrders}?status=canceled`,
      },
    ],
  },
  {
    name: 'Refund Requests',
    href: '#',
    icon: <PiReceiptLight />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'All',
        href: `${routes.eCommerce.refunds}?status=all`,
      },
      {
        name: 'Pending',
        href: `${routes.eCommerce.refunds}?status=Pending`,
      },
      {
        name: 'Approved',
        href: `${routes.eCommerce.refunds}?status=Approved`,
      },
      {
        name: 'Refunded',
        href: `${routes.eCommerce.refunds}?status=Refunded`,
      },
      {
        name: 'Rejected',
        href: `${routes.eCommerce.refunds}?status=Rejected`,
      },
    ],
  },

  {
    name: 'Purchase Order List',
    href: routes.poPageList,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hasPoPage', 'EMPLOYEE'],
  },
  {
    name: 'Purchase Order Setting',
    href: routes.poPage,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hasPoPage', 'EMPLOYEE'],
  },
  {
    name: 'Proforma Invoice List',
    href: routes.proFormaListTable,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hasProformaInvoice', 'EMPLOYEE'],
  },
  {
    name: 'Proforma Invoice Setting',
    href: routes.proformaPage,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hasProformaInvoice', 'EMPLOYEE'],
  },
  {
    name: 'Billing Settings',
    href: routes.forms.billingSettings,
    icon: <PiCreditCard />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },
  {
    name: 'Stripe',
    href: routes.stripe,
    icon: <PiCreditCard />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hasstripe', 'EMPLOYEE'],
  },
  {
    name: 'Payments Settings',
    href: routes.paymentsSettings,
    icon: <PiCreditCard />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },
  {
    name: 'Attributes & Units Settings',
    href: routes.attributesUnitsSettings,
    icon: <PiCube />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },

  // report management functionality

  {
    name: 'Report management',
    helpModal: 'REPORTS_HELP',
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
  },

  {
    name: 'Order Report',
    href: routes.eCommerce.orderreports,
    icon: <HiDocumentReport />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
  },
  {
    name: 'Sales Report',
    href: routes.eCommerce.salereports,
    icon: <BiSolidReport />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
  },

  {
    name: 'Product Report',
    href: routes.eCommerce.productreports,
    icon: <TbReport />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
  },

  {
    name: 'Product management',
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
  },
  {
    name: 'Categories',
    href: '#',
    helpModal: 'CATEGORIES_HELP',
    icon: <PiHardDrivesLight />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'Categories',
        href: routes.eCommerce.categories,
      },
      {
        name: 'Sub Categories',
        href: routes.eCommerce.subCategories,
      },
    ],
  },

  {
    name: 'Brands',
    href: '#',
    helpModal: 'BRANDS_HELP',
    icon: <PiHardDrivesLight />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],

    dropdownItems: [
      {
        name: 'Brand List',
        href: routes.eCommerce.brands,
      },
      // {
      //   name: 'Add New Brand',
      //   href: routes.eCommerce.createbrand,
      // },
    ],
  },

  {
    name: 'Units',
    href: '#',
    icon: <PiHardDrivesLight />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],

    dropdownItems: [
      {
        name: 'Unit List',
        href: routes.eCommerce.units,
      },
    ],
  },

  {
    name: 'Attributes',
    href: routes.eCommerce.attributes,
    icon: <PiCirclesThreePlusBold />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
  },
  {
    name: 'Products',
    href: '#',
    helpModal: 'PRODUCTS_HELP',
    icon: <PiGarage />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],

    dropdownItems: [
      {
        name: 'Add New',
        href: routes.eCommerce.createProduct,
      },
      {
        name: 'List Products',
        href: routes.eCommerce.products,
      },
      // {
      //   name: 'Bulk Import',
      //   href: routes.eCommerce.products,
      // },
    ],
  },
  {
    name: 'Testimonial',
    href: routes.eCommerce.testimonialList,
    icon: <PiStar />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },
  //  dropdownItems:
  {
    name: 'Special Deals',
    href: '#',
    icon: <PiStar />,
    roles: ['VENDOR'],
    dropdownItems: [
      {
        name: 'Live Sale',
        href: routes.eCommerce.LiveSale,
      },
      {
        name: 'Deal Of The Day',
        href: routes.eCommerce.DealOfTheDay,
      },
    ],
  },

  {
    name: 'Subscriptions',
    roles: ['ADMIN'],
  },

  {
    name: 'Plans',
    href: routes.plans,
    icon: <PiStar />,
    roles: ['ADMIN', 'VENDOR'],
  },
  {
    name: 'Subscriber Reports',
    href: routes.subscriberReports,
    icon: <PiStar />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER'],
  },
  {
    name: 'Marketing management',
    href: '#',
    icon: <PiChartLineUp />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'ADMINUSER', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'Reviews',
        href: routes.eCommerce.reviews,
      },
      {
        name: 'Featured Deal',
        href: routes.eCommerce.FeaturedDeal,
      },
      {
        name: 'Banners',
        href: routes.eCommerce.banners,
      },
    ],
  },
  {
    name: 'Google Analytics',
    href: routes.pixel,
    icon: <PiChartLineUp />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hasGoogleAnalytics', 'EMPLOYEE'],
  },
 {
    name: 'Google Analytics Setting',
    href: routes.googleanalytics,
    icon: <PiChartBar />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER','hasGoogleAnalytics', 'EMPLOYEE'],
  },
   {
    name: 'Meta Data',
    href: routes.eCommerce.metaData,
    icon: <PiUserSwitch />,
    roles: ['VENDOR'],
  },
  {
    name: 'Pixel',
    href: routes.pixel2,
    icon: <PiChartLineUp />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'haspixel', 'EMPLOYEE'],
  },
  {
    name: 'Community Stories',
    href: routes.eCommerce.communities,
    icon: <PiImage />,
    roles: ['ADMIN', 'WHOLESALER', 'VENDOR', 'isCosmetic', 'EMPLOYEE'],
  },

  {
    name: 'Product Stories',
    href: routes.eCommerce.storiesProduct,
    icon: <PiImage />,
    roles: ['ADMIN', 'WHOLESALER', 'EMPLOYEE'],
  },

  {
    name: 'Coupon',
    href: routes.eCommerce.coupons,
    icon: <PiTag />,
    roles: ['ADMIN', 'VENDOR', 'EMPLOYEE'],
  },
  {
    name: 'Wallets',
    href: routes.wallets,
    icon: <PiImage />,
    roles: ['WHOLESALER', 'VENDOR', 'ADMINUSER', 'EMPLOYEE', 'DELIVERY MAN'],
  },
  


  {
    name: 'Instagram',
    href: '#',
    icon: <PiInstagramLogo />,
    roles: ['ADMIN', 'VENDOR', 'hasinstagram', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'Add Instagram Account Deatils',
        href: `${routes.instagram}`,
      },
      {
        name: 'Campaigns',
        href: `${routes.eCommerce.InstaCampaign}`,
      },
      {
        name: 'Ads Sets',
        href: `${routes.eCommerce.InstaAdSets}`,
      },
      {
        name: 'Creatives',
        href: `${routes.eCommerce.InstaCreative}`,
      },
      {
        name: 'Ads',
        href: `${routes.eCommerce.InstaAds}`,
      },
    ],
  },
  {
    name: 'Facebook',
    href: '#',
    icon: <PiFacebookLogo />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hasfacebook', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'Account',
        href: `${routes.facebook}`,
      },
      {
        name: 'Create Ad',
        href: `${routes.facebookCreateAd}`,
        group: 'Ads',
      },
      {
        name: 'Campaigns',
        href: `${routes.eCommerce.FbCampaign}`,
        group: 'Ads',
      },
      {
        name: 'Ad Sets',
        href: `${routes.eCommerce.FbAdSets}`,
        group: 'Ads',
      },
      {
        name: 'Creatives',
        href: `${routes.eCommerce.FbCreative}`,
        group: 'Ads',
      },
      {
        name: 'Ads',
        href: `${routes.eCommerce.FbAds}`,
        group: 'Ads',
      },
      {
        name: 'Leads',
        href: `${routes.eCommerce.FbLeads}`,
      },
    ],
  },
  {
    name: 'Marketing CRM',
    href: '#',
    icon: <PiPhoneCall />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hascrm', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'Dashboard',
        href: `${routes.eCommerce.CRMAdmin}`,
      },
      {
        name: 'Leads',
        href: `${routes.eCommerce.CRMLeads}`,
      },
      {
        name: 'Agents',
        href: `${routes.eCommerce.CRMTelecallers}`,
      },
      {
        name: 'Performance',
        href: `${routes.eCommerce.CRMPerformance}`,
      },
      {
        name: 'Settings',
        href: `${routes.eCommerce.CRMSettings}`,
      },
    ],
  },
  {
    name: 'AI Sales Engine',
    href: routes.eCommerce.aiSales,
    icon: <PiRocketLaunch />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hasaisales', 'EMPLOYEE'],
  },
  {
    name: 'Transaction management',
    roles: ['ADMIN', 'EMPLOYEE'],
  },
  {
    name: 'Manage Beneficiary',
    href: routes.beneficary,
    icon: <PiImage />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },
  {
    name: 'Wallet Reports',
    href: routes.walletReports,
    icon: <PiImage />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },
  {
    name: 'Withdraw Reports',
    href: routes.withdrawReports,
    icon: <PiImage />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },

  {
    name: 'User Managment',
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },
  {
    name: 'Resellers',
    href: routes.eCommerce.reseller,
    icon: <PiUser />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },
  {
    name: 'Customers',
    href: routes.eCommerce.customers,
    icon: <PiUser />,
    roles: ['ADMIN', 'VENDOR', 'EMPLOYEE'],
  },
  
  {
    name: 'Suppliers',
    href: routes.eCommerce.wholesalersRequest,
    icon: <PiUser />,
    roles: ['ADMIN'],
  },
    {
    name: 'Comission',
    href: routes.eCommerce.commission,
    icon: <PiUser />,
    roles: ['ADMIN'],
  },
   {
    name: 'Deleted User',
    href: routes.eCommerce.deletedUsers,
    icon: <PiUser />,
    roles: ['ADMIN'],
  },
  {
    name: 'Connect with Suppliers',
    href: routes.eCommerce.wholesaler,
    icon: <PiUser />,
    roles: ['VENDOR'],
  },
  {
    name: 'My Suppliers',
    href: routes.eCommerce.mywholesalers,
    icon: <PiUser />,
    roles: ['VENDOR', 'EMPLOYEE'],
  },
  {
    name: 'Reseller Request',
    href: routes.eCommerce.connectionRequst,
    icon: <PiUser />,
    roles: ['WHOLESALER'],
    dropdownItems: [
      {
        name: 'All',
        href: `${routes.eCommerce.connectionRequst}?status=all`,
      },
      {
        name: 'Pending',
        href: `${routes.eCommerce.connectionRequst}?status=pending`,
      },
      {
        name: 'Approved',
        href: `${routes.eCommerce.connectionRequst}?status=approved`,
      },
    ],
  },

  {
    name: 'My Retailers',
    href: routes.eCommerce.wholesalerRetailers,
    icon: <PiUser />,
    roles: ['WHOLESALER'],
  },
  {
    name: 'Delivery Rates',
    href: routes.deliveryRates,
    icon: <PiPackage />,
    roles: ['WHOLESALER'],
  },
  {
    name: 'Branding Settings',
    href: routes.eCommerce.wholesalerBranding,
    icon: <PiUser />,
    roles: ['WHOLESALER'],
  },
  {
    name: 'Plan Pricing',
    href: routes.eCommerce.wholesalerPlanPricing,
    icon: <PiTag />,
    roles: ['WHOLESALER'],
  },
  {
    name: 'Employees',
    href: routes.eCommerce.employees,
    icon: <PiStudent />,
    roles: ['ADMIN', 'VENDOR', 'EMPLOYEE'],
    dropdownItems: [
      { name: 'Overview', href: routes.eCommerce.employeeOverview },
      { name: 'All Employees', href: routes.eCommerce.employees },
      { name: 'Performance', href: routes.eCommerce.employeePerformance },
      { name: 'KPI Settings', href: routes.eCommerce.employeeKpiSettings },
    ],
  },
  {
    name: 'Delivery Man',
    href: routes.eCommerce.deliveryMan,
    icon: <PiPersonSimpleBike />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER'],
    dropdownItems: [
      {
        name: 'List',
        href: routes.eCommerce.deliveryMan,
      },

      // {
      //   name: 'Chat',
      //   href: routes.eCommerce.deliveryManChatList,
      // },

      //  {
      //   name: 'Orders',
      //   href: routes.eCommerce.deliveryManOrder,
      // },

      // {
      //   name: 'Withdraws',
      //   href: routes.eCommerce.deliveryMan,
      // },

      // {
      //   name: 'Emergency Contact',
      //   href: routes.eCommerce.deliveryMan,
      // },
    ],
  },
  {
    name: 'Verified Wholesaler',
    href: routes.eCommerce.verifywholesaler,
    icon: <PiStudent />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },
  {
    name: 'Amount Locker',
    href: routes.eCommerce.amountLocker,
    icon: <PiStudent />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },

  {
    name: 'Import for Reseller',
    href: routes.eCommerce.resellerImport,
    icon: <PiUserSwitch />,
    roles: ['ADMIN'],
  },
   {
    name: 'Suppliers',
    href: routes.eCommerce.wholesalersRequest,
    icon: <PiUserSwitch />,
    roles: ['ADMIN'],
  },
  {
    name: 'Reseller Subscription',
    href: routes.eCommerce.subscription,
    icon: <PiPackage />,
    roles: ['ADMIN'],
  },
  {
    name: 'Commission',
    href: routes.eCommerce.commission,
    icon: <PiUser />,
    roles: ['ADMIN', 'EMPLOYEE'],
  },

  {
    name: 'Vendor Management',
    roles: ['VENDOR', 'hasmultivendor'],
  },
  {
    name: 'Vendors Setup',
    href: routes.eCommerce.vendors,
    icon: <PiPaintBrush />,
    roles: ['VENDOR', 'hasmultivendor'],
  },
  {
    name: 'Vendor Products',
    href: routes.eCommerce.vendorProducts,
    icon: <PiUser />,
    roles: ['VENDOR', 'hasmultivendor'],
    dropdownItems: [
      {
        name: 'New Products Requests',
        href: routes.eCommerce.vendorNewProducts,
      },
      {
        name: 'Approved Products',
        href: routes.eCommerce.vendorApprovedProducts,
      },
      {
        name: 'Denied Products',
        href: routes.eCommerce.vendorDeniedProducts,
      },
    ],
  },
  {
    name: 'Theme Management',
    roles: ['ADMIN', 'VENDOR', 'EMPLOYEE'],
  },
  {
    name: 'Theme Setup',
    href: routes.themeSetup,
    icon: <PiPaintBrush />,
    roles: ['ADMIN', 'VENDOR', 'DEVELOPER', 'EMPLOYEE', 'WHOLESALER'],
  },
  {
    name: 'Marketplace',
    href: routes.marketplace,
    icon: <PiStorefrontBold />,
    roles: ['ADMIN', 'VENDOR', 'DEVELOPER', 'EMPLOYEE', 'WHOLESALER'],
  },
  


  {
    name: 'Wallet Recharges',
    href: routes.recharge,
    icon: <PiImage />,
    roles: ['ADMIN'],
  },
  {
    name: 'Theme Recharge',
    href: routes.themeReacharged,
    icon: <PiImage />,
    roles: ['ADMIN'],
  },
  {
    name: 'Themes on Sale',
    href: routes.adminSaleTheme,
    icon: <PiImage />,
    roles: ['ADMIN'],
  },
  {
    name: 'Themes List',
    href: routes.adminProjectList,
    icon: <PiImage />,
    roles: ['ADMIN'],
  },
  {
    name: 'App Management',
    icon: <PiPaintBrush />,
    roles: ['ADMIN', 'VENDOR', 'EMPLOYEE'],
  },
  {
    name: 'Mobile Setup',
    href: routes.mobileSetup,
    icon: <PiPaintBrush />,
    roles: ['ADMIN'],
  },

  // {
  //   name: 'App',
  //   href: routes.appSetup,
  //   icon: <PiPaintBrush />,
  //   roles: ['ADMIN','VENDOR'],
  // },
  {
    name: 'App Build List',
    href: routes.appList,
    icon: <PiHardDrivesLight />,
    roles: ['ADMIN', 'VENDOR'],
  },
  {
    name: 'Settings',
    roles: ['ADMIN', 'VENDOR'],
  },
  // {
  //   name: 'Offline Payment',
  //   href: routes.offlinepayment,
  //   icon: <PiWrench />,
  //   roles: ['ADMIN', 'VENDOR', 'hasofflinepayment', 'EMPLOYEE', 'WHOLESALER'],
  // },
   {
    name: 'Enquires',
    href: routes.enquires,
    icon: <PiWrench />,
    roles: ['ADMIN', 'VENDOR', 'hasenquires', 'EMPLOYEE', 'WHOLESALER'],
  },
  {
    name: 'General Setup',
    href: routes.general,
    icon: <PiGear />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },

  {
    name: 'Plugin Setup',
    href: routes.paymentGateway,
    icon: <PiWrench />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
  },
  {
    name: 'Community Plugins',
    href: routes.communityPlugins,
    icon: <PiWrench />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER'],
  },

 

  {
    name: 'project list',
    href: routes.projectList,
    icon: <PiPaintBrush />,
    roles: ['DEVELOPER'],
  },
  {
    name: 'WhatsApp',
    href: routes.whatsappSetup,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hasWhatsApp', 'EMPLOYEE', 'WHOLESALER'],
    dropdownItems: [
      {
        name: 'Setup',
        href: routes.whatsappSetup,
        roles: ['ADMIN', 'VENDOR', 'hasWhatsApp', 'EMPLOYEE', 'WHOLESALER'],
      },
      {
        name: 'Notification Templates',
        href: routes.whatsappTemplates,
        roles: ['ADMIN', 'VENDOR', 'hasWhatsApp', 'EMPLOYEE', 'WHOLESALER'],
      },
      {
        name: 'API & Webhooks',
        href: routes.whatsappApiDocs,
        roles: ['ADMIN', 'VENDOR', 'hasWhatsApp', 'EMPLOYEE', 'WHOLESALER'],
      },
    ],
  },
   {
    name: 'Billing Invoice',
    href: routes.billinginvoice,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hasbillinginvoice', 'EMPLOYEE', 'WHOLESALER'],
  },
  {
    name: 'Firebase',
    href: routes.firebaseSetup, 
    icon: <PiBellRingingDuotone />, 
    roles: ['ADMIN', 'VENDOR', 'hasFirebase', 'EMPLOYEE', 'WHOLESALER'],
  },
  {
    name: '2 Factor',
    href: routes.twofactorSetup,
    icon: <PiChatTeardropText />,
    roles: ['ADMIN', 'VENDOR', 'hastwofactor', 'EMPLOYEE', 'WHOLESALER'],
  },
  //hasPoPage

  {
    name: 'Twilio',
    href: routes.twilioSetup,
    icon: <PiPhoneCall />,
    roles: ['ADMIN', 'VENDOR', 'hasTwilio', 'EMPLOYEE', 'WHOLESALER'],
  },
  {
    name: 'Google Configuration',
    href: routes.googlePlugin,
    icon: <PiCirclesThreePlusBold />,
    roles: ['ADMIN','hasGoogle', 'VENDOR'],
  },

  // googleanalytics
 
  {
    name: 'Pixel Setting',
    href: routes.pixelSetting,
    icon: <PiChartBar />,
    roles: ['ADMIN', 'VENDOR', 'haspixel', 'EMPLOYEE'],
  },
  {
    name: 'Shiprocket',
    href: routes.shipRocket,
    icon: <PiRocketLaunch />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hasShiprocket', 'EMPLOYEE'],
  },
  {
    name: 'Payment Gateway',
    href: routes.paymentGateways,
    icon: <PiCreditCard />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'hasPaymentGateway', 'EMPLOYEE'],
    dropdownItems: [
      {
        name: 'CashFree',
        href: routes.cashFree,
        icon: <PiRocketLaunch />,
        roles: ['hasCashfree'],
      },
      {
        name: 'PhonePay',
        href: routes.phonePay,
        roles: ['hasPhonepe'],
      },
      {
        name: 'Razorpay',
        href: routes.razorpay,
        roles: ['hasRazorpay'],
      },
      {
        name: 'PayU',
        href: routes.payu,
        roles: ['haspayu'],
      },
      {
        name: 'Stripe',
        href: routes.stripe,
        roles: ['hasStripe'],
      },
    ],
  },
  {
    name: 'Pages & Media',
    href: routes.socialMedia,
    icon: <PiFile />,
    roles: ['ADMIN', 'VENDOR', 'WHOLESALER', 'EMPLOYEE'],
    style: { marginBottom: '35px' },
    dropdownItems: [
      {
        name: 'Pages',
        href: routes.pages,
      },
      {
        name: 'Social Media',
        href: routes.socialMedia,
      },
       {
        name: 'Blog',
        href: routes.blog,
      },
    ],
  },
];

export const compactSidebarLayout = {
  quickLinks: [
    {
      label: 'Point Of Sale',
      itemNames: ['POS'],
      children: [],
    },
    // {
    //   label: "What's new",
    //   itemNames: ['Home'],
    //   children: [],
    // },
  ],
  mainLinks: [
    {
      label: 'Home',
      itemNames: ['Dashboard'],
      children: [],
    },
   {
  label: 'Orders',
  itemNames: ['Orders'],
  children: ['Orders', 'Refund Requests', 'Offline Order','Enquires'],
},
   
    {
      label: 'Products',
      itemNames: ['Products'],
      children: [
        {
          label: 'Inventory',
          itemNames: ['Products'],
          childNames: ['List Products'],
        },
        {
          label: 'Categories',
          itemNames: ['Categories'],
          childNames: ['Categories'],
        },
        {
          label: 'Brands',
          itemNames: ['Brands'],
          childNames: ['Brand List'],
        },
{
  label: 'Attributes & Units',
  itemNames: ['Attributes & Units Settings'],
}
      ],
    },
    {
      label: 'Marketing',
      itemNames: ['Marketing management'],
      children: [
        {
          label: 'Reviews',
          itemNames: ['Marketing management'],
          childNames: ['Reviews'],
        },
        {
          label: 'Featured Deal',
          itemNames: ['Marketing management'],
          childNames: ['Featured Deal'],
        },
        {
          label: 'Banners',
          itemNames: ['Marketing management'],
          childNames: ['Banners'],
        },
      ],
    },
    {
  label: 'Delivery Partner',
  itemNames: ['Delivery Man'],
  children: [
    {
      label: 'Delivery Partner List',
      itemNames: ['Delivery Man'],
      childNames: ['List'],
    },
  ],
},
 {
  label: 'Testimonial',
  itemNames: ['Testimonial'],
},,
    {
      label: 'Analytics',
      itemNames: ['Analytics', 'Google Analytics Setting', 'Google Analytics', 'Pixel'],
      children: [
        {
          label: 'Store Analytics',
          itemNames: ['Analytics'],
        },
        {
          label: 'Order Reports',
          itemNames: ['Order Report'],
        },
        {
          label: 'Product Reports',
          itemNames: ['Product Report'],
        },
        {
          label: 'Sales Reports',
          itemNames: ['Sales Report'],
        },
      ],
    },

    {
      label: 'Discounts',
      itemNames: ['Coupon'],
      children: [
        {
          label: 'Coupons',
          itemNames: ['Coupon'],
        },
        {
          label: 'Deal Of the Day',
          itemNames: ['Special Deals'],
          childNames: ['Deal Of The Day'],
        },
        {
          label: 'Live Sale',
          itemNames: ['Special Deals'],
          childNames: ['Live Sale'],
        },
      ],
    },
    {
      label: 'Customers',
      itemNames: ['Customers'],
      children: [],
    },

    {
      label: 'Wallet',
      itemNames: ['Wallets'],
      children: [],
    },
   
    {
     label:'Reseller Subcribtion',
     itemNames: ['Reseller Subscription']
    },
    {
    label:'Wallet Recharges',
    itemNames: ['Wallet Recharges']
  },
 {
    label:'Import Reseller',
    itemNames: ['Import for Reseller']
  },
 {
    label:'Suppliers',
    itemNames: ['Suppliers']
  },
   {
    label:'Comission',
    itemNames: ['Comission']
  },
     {
    label:'Deleted User',
    itemNames: ['Deleted User']
  },
    {
      label: 'My Retailers',
      itemNames: ['My Retailers', 'Reseller Request'],
      children: [
        {
          label: 'Retailer List',
          itemNames: ['My Retailers'],
        },
        {
          label: 'Requests',
          itemNames: ['Reseller Request'],
          childNames: ['All'],
        },
      ],
    },
    {
      label: 'Branding Settings',
      itemNames: ['Branding Settings'],
      children: [],
    },
    {
      label: 'Plan Pricing',
      itemNames: ['Plan Pricing'],
      children: [],
    },
  ],
  appsTitle: 'Apps & Plugins',
  appLinks: [
    {
      label: 'Whatsapp Support',
      itemNames: ['WhatsApp'],
      children: [],
    },
    {
      label: 'Google Analytics',
      itemNames: ['Google Analytics Setting', 'Google Analytics'],
      children: [],
    },
    {
      label: 'Facebook Pixels',
      itemNames: ['Facebook', 'Pixel Setting', 'Pixel'],
      children: [],
    },
    {
      label: 'Community Plugins',
      itemNames: ['Community Plugins'],
      children: [],
    },
  ],
  addAction: {
    label: 'Add App',
    itemNames: ['Plugin Setup'],
  },
  footerAction: {
    label: 'Manage Suppliers',
    itemNames: ['Suppliers', 'My Suppliers', 'Connect with Suppliers'],
  },
} as const;

export const settingsSidebarPaths = [
  routes.general,
  routes.paymentsSettings,
  routes.paymentGateway,
  routes.paymentGateways,
  routes.themeSetup,
  // routes.attributesUnitsSettings,
  routes.forms.billingSettings,
  routes.eCommerce.attributes,
  routes.eCommerce.units,
  // routes.googleanalytics,
  routes.pixelSetting,
  // routes.facebook,
  routes.eCommerce.employees,
  routes.mobileSetup,
  routes.appList,
  //  routes.billinginvoice,
    routes.socialMedia,   
  routes.pages, 
  routes.blog,
  routes.forms.profileSettings,
   routes.eCommerce.communities,
  routes.deliveryRates,
] as const;

export const settingsSidebarLayout = {
  title: 'My Store',
  items: [
    {
      label: 'General',
      itemNames: ['General Setup'],
    },
    {
      label: 'Billing',
      itemNames: ['Billing Settings'],
    },
    {
      label: 'Payments',
      itemNames: ['Payments Settings'],
    },
    {
      label: 'Payment Gateways',
      itemNames: ['Payment Gateway'],
    },
    //   {
    //   label: 'Offline Payment',
    //   itemNames: ['Offline Payment'],
    // }, 
    //   {
    //   label: 'Enquires',
    //   itemNames: ['Enquires'],
    // }, 
    {
      label: 'Plugin Setup',
      itemNames: ['Plugin Setup'],
    },
    {
      label: 'Shipping Methods',
      itemNames: ['Shiprocket'],
      href: routes.shipRocket,
    },
    {
      label: 'Community Stories',
      itemNames:['Community Stories'], 
    },
    {
      label: 'Delivery Rates',
      itemNames: ['Delivery Rates'],
    },
    {
      label: 'Theme Marketplace',
      itemNames: ['Theme Setup'],
    },
  {
      label: 'Theme Recharge',
      itemNames: ['Theme Recharge'],
    },
      {
      label: 'Themes on Sale',
      itemNames: ['Themes on Sale'],
    },
    {
  label: 'Pages & Media',
  itemNames: ['Pages & Media'],
  roles: ['ADMIN', 'VENDOR','WHOLESALER', 'EMPLOYEE'],
  children: [
    {
      label: 'Pages',
      itemNames: ['Pages & Media'],
      childNames: ['Pages'],
    },
    {
      label: 'Social Media',
      itemNames: ['Pages & Media'],
      childNames: ['Social Media'],
    },
     {
      label: 'Blog',
      itemNames: ['Pages & Media'],
      childNames: ['Blog'],
    },
  ],
},
 {
  label: 'App Management',
  itemNames: ['Mobile Setup'], // used for active detection
  roles: ['ADMIN', 'VENDOR'],
  children: [
    {
      label: 'Mobile Setup',
      itemNames: ['Mobile Setup'],
    },
    {
      label: 'App Build List',
      itemNames: ['App Build List'],
    },
  ],
},
    // {
    //   label: 'Attributes & Units',
    //   itemNames: ['Attributes & Units Settings'],
    // },
    {
      label: 'Employees',
      itemNames: ['Employees'],
    },
    // {
    //   label: 'Mobile Application',
    //   itemNames: ['Mobile Setup'],
    // },
  ],
} as const;
